import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './styles/tokens.css';
import { App } from './App';
import { preventFocusZoomOnApple } from './styles/ios-viewport';
// After every component's styles (owner request 2026-10-01, the app's look).
import './styles/theme.css';

preventFocusZoomOnApple(document, navigator);

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Missing #root element in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
